(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bf-bis"] && !Shopify.designMode) return;
  try {
    (function () {
  var modal, intro, tags, note, form, wrap, done, product;
  function grab() {
    modal = document.querySelector('[data-bf-bis-modal]');
    if (!modal) return false;
    intro = modal.querySelector('[data-bf-bis-intro]');
    tags = modal.querySelector('[data-bf-bis-tags]');
    note = modal.querySelector('[data-bf-bis-note]');
    form = modal.querySelector('form');
    wrap = modal.querySelector('[data-bf-bis-form-wrap]');
    done = modal.querySelector('[data-bf-bis-done]');
    product = modal.getAttribute('data-product') || '';
    return true;
  }
  function open(variantId, size) {
    if (!modal && !grab()) return;
    if (intro) intro.textContent = 'Laissez votre e-mail : on vous prévient dès que « ' + product + ' » revient en pointure ' + size + '.';
    if (tags) tags.value = 'back-in-stock,bis-' + variantId;
    if (note) note.value = 'Retour en stock demandé : ' + product + ' — pointure ' + size + ' (variante ' + variantId + ')';
    if (wrap) wrap.hidden = false;
    if (done) done.hidden = true;
    modal.hidden = false; modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var email = modal.querySelector('[data-bf-bis-email]'); if (email) setTimeout(function () { email.focus(); }, 40);
  }
  function close() { if (!modal) return; modal.hidden = true; modal.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bf-bis]');
    if (trigger) {
      e.preventDefault(); e.stopPropagation();
      open(trigger.getAttribute('data-bf-bis'), trigger.getAttribute('data-bf-bis-size') || '');
      return;
    }
    if (e.target.closest('[data-bf-bis-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form');
    if (!f || !modal || !modal.contains(f)) return;
    e.preventDefault();
    f.classList.add('is-loading');
    var data = new FormData(f);
    fetch(f.action, { method: 'POST', body: data, headers: { 'Accept': 'text/html' } })
      .then(function () { showDone(); })
      .catch(function () { showDone(); }); // le client est cree cote Shopify meme si la reponse HTML n'est pas lisible en AJAX
    function showDone() { f.classList.remove('is-loading'); if (wrap) wrap.hidden = true; if (done) done.hidden = false; }
  });

  if (document.readyState !== 'loading') grab(); else document.addEventListener('DOMContentLoaded', grab);
})();
  } catch(e) { console.error(e); }
})();

})();
